import React from 'react';

import CustomExports from '../components/exports/CustomExports';
import ApptopiaExports from '../components/exports/ApptopiaExports';
import Container from '../../../components/Container';

const Exports = () => (
  <Container maxWidth={1128} className="py-mdl">
    <div className="stack-vertical gap-24">
      <CustomExports />
      <ApptopiaExports />
    </div>
  </Container>
);

export default Exports;
